import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import styles from './ArticleBody.module.styl';
import makeSrcSet from '../../lib/makeSrcSet';
import sizeImage from '../../lib/sizeImage';

const BodyPhoto = ({ url, caption, credit }) => {
  const [isVisible, setIsVisible] = React.useState(false);
  const srcSet = makeSrcSet(url, [960, 800, 600, 320]);
  return (
    <VisibilitySensor
      onChange={(value) => {
        if (value) {
          // Only set this once.
          setIsVisible(value);
        }
      }}
      partialVisibility
      delayedCall
      minTopValue={200}
    >
      <figure className={classNames(styles.photoWrapper, { [styles.inView]: isVisible })}>
        <picture className={styles.photo}>
          <img
            src={sizeImage({ width: 960, src: url })}
            sizes="(min-width: 960px) 960w, 100vw"
            srcSet={srcSet}
            alt={caption}
          />
        </picture>
        <small className={classNames(styles.photoCredit, 'bentoncond-n4')}>
          {credit}
        </small>
        <figcaption className={styles.photoCaption}>
          {caption}
        </figcaption>
      </figure>
    </VisibilitySensor>
  );
};

BodyPhoto.propTypes = {
  url: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  credit: PropTypes.string,
};

BodyPhoto.defaultProps = {
  credit: '',
};

export default BodyPhoto;
